import { ReportStatus } from '@signalvote/shared';
import type { ComplianceReportDto } from '@signalvote/shared';
import { useFinanceReports } from '@/hooks/queries';

// An amendment being prepared is created Ready and stays Ready until it is filed. It is a filing the
// treasurer owes even when no deadline is open. The server allows one per filing chain, and a chain
// is one period, so an amendment's period names the filing it corrects.
export function useOpenAmendments(): ComplianceReportDto[] {
  const { data } = useFinanceReports({ status: ReportStatus.Ready, pageSize: 20 });
  return data?.items?.filter((r) => r.isAmendment) ?? [];
}
